export enum BadgeType {
    DEFAULT = 'default',
    CUSTOM = 'custom',
}

export interface Badge {
    iconFilename: string
    iconId: string
    id: string
    isActive: boolean
    name: string
    points: number
    totalPoints: number
    type: string
}
